import { render } from "./ContactMessageModal.vue?vue&type=template&id=3b046290&scoped=true&ts=true"
import script from "./ContactMessageModal.vue?vue&type=script&lang=ts"
export * from "./ContactMessageModal.vue?vue&type=script&lang=ts"

import "./ContactMessageModal.vue?vue&type=style&index=0&id=3b046290&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b046290"]])

export default __exports__